import { createSvgIcon } from '@mui/material';

const Roulette = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
    xmlSpace="preserve"
  >
    <g>
      <path d="M456,232c0-47.576-16.991-93.676-47.844-129.807c-27.703-32.444-65.031-55.167-106.165-64.871l23.665-23.666
        c2.288-2.288,2.973-5.729,1.734-8.718S323.236,0,320,0H192c-3.236,0-6.153,1.949-7.391,4.938s-0.554,6.43,1.734,8.718
        l23.665,23.665c-41.122,9.702-78.441,32.415-106.143,64.847C72.999,138.303,56,184.412,56,232c0,87.908,57.01,162.751,136,189.499
        V456h-53c-6.065,0-11,4.935-11,11v37c0,4.418,3.582,8,8,8h240c4.418,0,8-3.582,8-8v-37c0-6.065-4.935-11-11-11h-53v-34.501
        C398.99,394.751,456,319.908,456,232z M300.687,16L256,60.687L211.313,16H300.687z M321.678,118.242
        c1.26,0.728,2.635,1.073,3.993,1.073c2.765,0,5.454-1.435,6.936-4.001l6.19-10.722c17.79,11.601,33.011,26.821,44.611,44.611
        l-81.552,47.084c-2.932,1.693-4.379,4.961-3.906,8.117c-0.423,1.797-0.235,3.747,0.682,5.514c3.562,6.86,5.367,14.29,5.367,22.082
        c0,26.467-21.533,48-48,48s-48-21.533-48-48s21.533-48,48-48c7.636,0,14.932,1.737,21.685,5.164
        c1.634,0.83,3.416,1.036,5.088,0.723c0.662,0.172,1.336,0.258,2.005,0.258c2.765,0,5.454-1.435,6.936-4.001l25.608-44.354
        c2.209-3.826,0.898-8.719-2.928-10.928c-3.826-2.21-8.719-0.899-10.928,2.928l-22.643,39.22c-5.396-2.28-11.019-3.791-16.821-4.508
        V80.21c21.848,1.138,42.489,6.912,60.957,16.353l-6.207,10.751C316.541,111.14,317.852,116.033,321.678,118.242z" />
      <path d="M283.512,216.908l-13.158-3.879l-7.755-11.315c-1.492-2.177-3.96-3.478-6.599-3.478s-5.107,1.301-6.599,3.478
        l-7.755,11.315l-13.158,3.879c-2.531,0.746-4.531,2.692-5.346,5.201s-0.341,5.259,1.268,7.351l8.365,10.872l-0.377,13.712
        c-0.072,2.638,1.16,5.142,3.295,6.692s4.896,1.949,7.382,1.065L256,257.206l12.925,4.596c0.872,0.31,1.778,0.462,2.68,0.462
        c1.667,0,3.317-0.521,4.703-1.528c2.135-1.551,3.367-4.055,3.295-6.692l-0.377-13.712l8.365-10.872
        c1.609-2.091,2.083-4.841,1.268-7.351S286.043,217.654,283.512,216.908z M264.81,232.83c-1.122,1.458-1.707,3.259-1.657,5.099
        l0.135,4.887l-4.607-1.638c-0.867-0.308-1.773-0.462-2.68-0.462s-1.813,0.154-2.68,0.462l-4.607,1.638l0.135-4.887
        c0.05-1.839-0.535-3.64-1.657-5.099l-2.982-3.875l4.69-1.383c1.765-0.52,3.296-1.633,4.337-3.151l2.764-4.033l2.764,4.033
        c1.041,1.518,2.572,2.631,4.337,3.151l4.69,1.383L264.81,232.83z" />
    </g>
  </svg>,
  'Roulette'
);

export default Roulette;
